export default __webpack_public_path__ + "static/media/nutztierfutter.600x550.13964783.jpg";